import React from 'react';
import classNames from 'classnames';
import Modal from './common/Modal';
import Button from './ui/Button';

const AlertModal = ({
  type = 'confirm',
  children,
  onOK,
  onCancel,
  okText = 'Confirm',
  cancelText = 'Cancel',
  okLoading = false,
  ...props
}) => {
  return (
    <Modal {...props} width="md">
      {children}
      <footer className="flex gap-3 justify-end pt-4">
        <Button
          onClick={onCancel}
          variant=""
          className="px-5 py-2 border font-semibold border-light-gray text-black active:border-primary-main"
        >
          {cancelText}
        </Button>
        <Button
          onClick={onOK}
          className={classNames('px-5 py-2', {
            'text-error bg-transparent border-error': type === 'warning',
          })}
          loading={okLoading}
        >
          {okText}
        </Button>
      </footer>
    </Modal>
  );
};

export default AlertModal;
